import { EmisEntry, InputData, OutputData } from './types';
const stdev = require('compute-stdev');

export const COMPACT_FONT_SIZE = 13;
export const COMPACT_LABEL_SIZE = 11;
export const FULL_FONT_SIZE = 16;
export const FULL_LABEL_SIZE = 13;

export function transformData(input: InputData): OutputData | void {
  if (!input) return;
  const result: OutputData = [];
  const equipmentTypes = input.equipment_type || input.facility_type;

  const uniqueTypes: string[] = [];
  for (const type of Object.values(equipmentTypes)) {
    if (!uniqueTypes.includes(type)) {
      uniqueTypes.push(type);
    }
  }

  uniqueTypes.forEach((type) => {
    const emissions: EmisEntry[] = [];

    for (const index in equipmentTypes) {
      if (equipmentTypes[index] === type) {
        const emissionsEntry: EmisEntry = {};

        Object.keys(input).forEach((key) => {
          if (key !== 'equipment_type' && input[key][index] !== undefined) {
            emissionsEntry[key] = input[key][index] as number;
          }
        });

        emissions.push(emissionsEntry);
      }
    }

    result.push({ type, emissions });
  });

  return result;
}

export function downloadCSV(data: any[]) {
  const csvRows = [];
  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(','));

  data.forEach((row) => {
    const values = headers.map((header) => row[header]);
    csvRows.push(
      values
        .map((e) => (typeof e === 'string' ? e : JSON.stringify(e)))
        .join(','),
    );
  });

  const csvContent = csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'chart-data.csv';
  link.click();
}

export const downloadIcon =
  'path://M11.29,16.71h0a1.15,1.15,0,0,0,.33.21.94.94,0,0,0,.76,0,1.15,1.15,0,0,0,.33-.21h0l4-4a1,1,0,0,0-1.42-1.42L13,13.59V3a1,1,0,0,0-2,0V13.59l-2.29-2.3a1,1,0,1,0-1.42,1.42Z M19,20H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2Z';

export const calculateConfidenceInterval = (emissionRates: number[]) => {
  const meanValue =
    emissionRates.reduce((sum: any, value: any) => sum + value, 0) /
    emissionRates.length;

  const standardDeviation = stdev(emissionRates);

  const confidenceInterval =
    (1.96 * standardDeviation) / Math.sqrt(emissionRates.length);
  const lowerBound = meanValue - confidenceInterval;
  const upperBound = meanValue + confidenceInterval;

  return {
    meanValue,
    lowerBound,
    upperBound,
  };
};
